export const CV_PARSE_FILE_TIMEOUT_MS = 90000; // серверное чтение файла + базовый парсинг
export const CV_PARSE_TEXT_TIMEOUT_MS = 120000; // AI-парсинг текста может занимать до 2 минут
export const ATS_ANALYSIS_TIMEOUT_MS = 120000; // ATS analysis AI pipeline — backend timeout 180s












